
import ImageContainer from '@/views/creative/components/image-container.vue';
import VideoContainer from '@/views/creative/components/video-container.vue';
import SequenceFrameContainer from '@/views/creative/components/frame-sequence.vue';
import AudioContainer from '@/views/creative/components/audio-container.vue';

export default {
  components: {
    ImageContainer: ImageContainer,
    VideoContainer: VideoContainer,
    AudioContainer: AudioContainer,
    SequenceFrameContainer: SequenceFrameContainer
  },

  props: {
    resource: Object,
    index: Number
  },

  data: function data() {
    return {
      imageStyle: {
        width: '200px',
        height: '150px',
        maxWidth: '200px',
        maxHeight: '150px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center'
      }
    };
  },


  computed: {
    dimensionWidth: function dimensionWidth() {
      if (this.resource.dimension === '-' || !this.resource.dimension) return 0;
      return this.resource.dimension.split('x')[0];
    },
    dimensionHeight: function dimensionHeight() {
      if (this.resource.dimension === '-' || !this.resource.dimension) return 0;
      return this.resource.dimension.split('x')[1];
    },

    // 龙骨比较特殊，需要读取image_url
    imageUrl: function imageUrl() {
      if (this.resource.cat1_id === 1 || this.resource.res_type === 10 && this.resource.cat1_id === 3 || this.resource.res_type === 16 || this.resource.res_type === 18) {
        return this.resource.image_url;
      }
      return this.resource.file_url;
    }
  }
};